export class ArticleSourceSearchRequest {
  MaxResults: number;
  VrmArticleID: number;
  ItemGroupDescription: string;
  Description: string;
  ItemNumber: string;
  Ean: string;
  ItemNumberSupplier: string;
}